import { useState } from "react";
import { func } from "prop-types";
import { useTranslation } from "react-i18next";
import { DASHBOARD_MODE } from "@utils";
import { PopMenu, MenuButton } from "@components";
import { IconButton } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

export const DashboardModeSelector = ({ onChange }) => {
  const {t} = useTranslation();
  
  const [ open, setOpen ] = useState(false);
  const [ anchorEl, setAnchorEl ] = useState(false);
  
  const handleOpen = () => setOpen(!open);
  const handleSelect = (mode) => {
    onChange(mode);
    setOpen(false);
  };
  
  return (
    <>
      <IconButton
        id="dashboardModeButton"
        ref={setAnchorEl}
        onClick={handleOpen}
        className="ml-1"
      >
        {open ? <ExpandLess /> : <ExpandMore />}
      </IconButton>
      <PopMenu
        id="dashboardModeMenu"
        anchor={anchorEl}
        show={open}
        onClickAway={handleOpen}
      >
        <MenuButton onClick={() => handleSelect(DASHBOARD_MODE.COMPANY)}>
          {t("dashboard_mode.company")}
        </MenuButton>
        <MenuButton onClick={() => handleSelect(DASHBOARD_MODE.SHARED)}>
          {t("dashboard_mode.shared")}
        </MenuButton>
      </PopMenu>
    </>
  );
};

DashboardModeSelector.propTypes = {
  onChange: func.isRequired,
};